// stickyState 1.0
// Created: 04/2018
// Updated:
// Created for: "Sticky" Options de commande
// Notes: Works on ie 11
// Require: resize-sensor.js

// Mandatory //

// data-module~="stickyState"
// data-sticky-element

// Optional //
// data-sticky-exclude: elements with height their heights excluded
// data-animation-selector: elements that have an animation inside de the sticky container

// Usage //

/*
    <div class="my-sticky-container" data-module~="stickyState">

	    <div class="sticky-sibling" data-animation-selector>
		    ...
		    <button class="expand-collapse"></button>
		    ...
	    </div>

	    <div class="sticky-element" data-sticky-element>...</div>

    </div>
*/

// Note : this plugin act as a singleton
// AJAX
//     $(window).stickyState('destroy');
//     $('[data-module~="stickyState"]').stickyState();
//     $('[data-module~="stickyState"]').stickyState(true); //destroy the module corresponding to the selector before create stickyState

(function ($) {
	'use strict';
	
	let stickyStateGlobalVar = {
		instance_index : 0
	}

    $.fn.stickyState = function (options) {
		// Default settings
		let settings = $.extend({
			destroy: false,
			animationSelectors: false
		}, options );

		const $window = $(window);

		var array = [].slice.call(this);
        for(var i=0; i < array.length; i++) {
			const app = array[i]; //container is where the data-module~="fixedSticky" is,
			const container = $(app).closest( app.getAttribute( 'data-container' ) )[0];
			const heightWatcher = $( app.getAttribute( 'data-height-watcher' ) );

            if ( container === null ) {
               continue;
			}
			const stickyDirection = app.getAttribute('data-sticky-direction');
			const containerStyleInitial = container.getAttribute('style');
			const containerPaddingBottomInitial = parseFloat( window.getComputedStyle( container ).paddingBottom );
			let stateCurrent = '';

            let stickySiblingsHeight,
                startScrollPosition,
                stopScroll,
                stickyInitialized = false,
				stickyElementOffsetTop = $(app).offset().top,
                fromTop = false;

			// ----- CUSTOM TINK -----
			let containerOffsetValue = app.getAttribute('data-container-offset');
			if (containerOffsetValue != null) {
				stickyElementOffsetTop -= containerOffsetValue;
			}
			// ----- END CUSTOM TINK -----

            function init() {
				$(app).data('id', stickyStateGlobalVar.instance_index++ );
				stickySiblingsHeight = 0;

				$(container).addClass( 'sticky-state-container' );
				
                if(stickyDirection === "top") {
                    stickySiblingsHeight = 0;
                    startScrollPosition = stickyElementOffsetTop;
                    stopScroll = $(app).offset().top;
                    fromTop = true;
                    stickyHasSpace(fromTop);
                } else {
                    stickySiblingsHeight = isAboveSticky();
                    startScrollPosition = ( $(app).prevAll('*:visible').first() === undefined )? stickyElementOffsetTop + $(app).outerHeight(true) : $(app).prevAll('*:visible').first().offset().top + $(app).prevAll('*:visible').first().outerHeight() + $(app).outerHeight(true);
                    stopScroll = ( $(container).offset().top + $(container).height() ) - containerPaddingBottomInitial ;
					stickyHasSpace(fromTop);
					
					app.classList.add( 'sticky-state-trigger' );
					container.classList.add( 'sticky-state-container' );
					if( $( container ).find( '.sticky-state-placeholder' ).length === 0 ) {
						$( container ).append(`<div class="sticky-state-placeholder" style="height:${$(app).height()}px;"></div>`);
					}
				}

				if( settings.animationSelectors ) {
					const $animationSelector = $(container).find('[data-animation-selector]').filter(function () {
						return $(this).closest( '.sticky-state-container' ).is( container );
					});
					
					$animationSelector.on(`animationend.${$(app).data('id')}`, function(){
						$animationSelector.off(`animationend.${$(app).data('id')}`);
						init();
					});
				}
            }

             var isAboveSticky = function() {
				var stickySiblings = Array.prototype.filter.call(app.parentNode.children, function(child){
					return child !== app;
				});

				for (var k=0; k < stickySiblings.length; k++) {
					var item = stickySiblings[k];

					if( !item.hasAttribute('data-sticky-exclude') ){
						const itemStyle = window.getComputedStyle(item);
						stickySiblingsHeight += ( item.offsetHeight + parseFloat( itemStyle.marginTop ) + parseFloat( itemStyle.marginBottom ) );
					}
				}
				
				return(stickySiblingsHeight);
            };

            var isSticky = function () {
				const $body = $(document.body);
				var offset = (stickyDirection === "top") ? window.pageYOffset : window.pageYOffset + window.innerHeight - containerPaddingBottomInitial;

                if(stickyDirection === "top") {
                    if (offset > startScrollPosition) {
                        $(app).addClass('position-fixed');
                        $(app).addClass('is_sticky');
						$body.addClass('sticky-active');
                    } else {
                        $(app).removeClass('position-fixed');
                        $(app).removeClass('is_sticky');
                        $('.ie').find('input').blur();
						$body.removeClass('sticky-active');
                    }
                } else {
                    if (offset > startScrollPosition && offset < stopScroll && stateCurrent !== 'fixed' ) {
						$(app).addClass('position-fixed');
                        $(app).removeClass('position-absolute');
                        stateCurrent = 'fixed';
						$(app).addClass('is_sticky');

                    } else if ( offset > stopScroll && stateCurrent !== 'absolute' ) {
                        $(app).addClass('position-absolute');
                        $(app).removeClass('position-fixed');
                        stateCurrent = 'absolute';
                        $(app).removeClass('is_sticky');
                    } else if( offset <= startScrollPosition && offset < stopScroll && stateCurrent !== 'relative' ) {
                        $(app).removeClass('position-absolute');
                        $(app).removeClass('position-fixed');
                        stateCurrent = 'relative';
                        $(app).removeClass('is_sticky');
                        $('.ie').find('input').blur();
                    }
                }
            };

            var stickyHasSpace = function (fromTop) {
                if(fromTop) {
                    if(!stickyInitialized) {
                        relaunchSticky();
                    }
                    isSticky();
                    (!stickyInitialized) ? relaunchSticky() : '';
                    stickyInitialized = true;
                } else {

                    if(container.offsetHeight - stickySiblingsHeight - $(app).outerHeight(true) > 0) {
                        if(!stickyInitialized) {
                            relaunchSticky();
                        }
                        isSticky();
                        stickyInitialized = true;
                    } else {
                        $(app).removeClass('position-absolute');
						$(app).removeClass('position-fixed');
						$window.off(`scroll.stickyState${$(app).data('id')}`);
                        stickyInitialized = false;
                    }
                }
			};
			
			const scrollHandler_trigger = _.throttle(isSticky, 50);
			const resizeCallback = _.throttle(function () {
				init();
			}, 200);
			const relaunchSticky = function () {
				$window.on(`scroll.stickyState${$(app).data('id')}`, scrollHandler_trigger);
			}

			if( settings.destroy === false ){
				// Detect height change above the sticky container
				if( heightWatcher !== null && !inExternalWebsite ) {
					new ResizeSensor(heightWatcher, function() {
						init();
					});
				}

				init();
				$window.on(`resize.stickyState${$(app).data('id')}`,  resizeCallback);
			
			} else if( settings.destroy ){
				if( containerStyleInitial !== null ) {
					container.setAttribute( 'style', containerStyleInitial );
				}
				$(app).removeClass( 'position-relative position-absolute position-fixed sticky-state-trigger' );
				$(container).removeClass('sticky-state-container');

				$window.off(`scroll.stickyState${$(app).data('id')}`);
				$window.off(`resize.stickyState${$(app).data('id')}`);
				$(container).find('button').off(`click.${$(app).data('id')}`);


				if( stickyDirection !== "top" ) {
					$( '.sticky-state-placeholder' ).remove();
				}
			}

		
		}
    }
})(jQuery);